/* eslint-disable */

import React, {useState} from 'react';
import Modal from 'react-modal';
import AlertBlue from '../../../../_assets/svg/alert-blue.svg';
import TermUseBahasa from '../../../../_assets/images/badge/term-use-bahasa.png';
import TermUseEnglish from '../../../../_assets/images/badge/term-use-english.png';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    borderRadius: '10px',
    padding: 0,
    minWidth: '667px',
    maxHeight: '90vh'
  },
};
function TermUseAuth() {
  const [isOpenModal, setOpenModal]=useState(false);
  return (
    <div>
    <Modal
      isOpen={isOpenModal}
      onRequestClose={()=>setOpenModal(true)}
      style={customStyles}
      contentLabel="Example Modal"
    >
    <div className="card p-3 pb-0 fsize-12 fweight-400">
      <div className='d-flex align-items-center justify-content-between px-3'>
        <h4 className='fsize-20 fweight-700'>Term of use template authentication</h4>
        <div className="close-action" onClick={()=>setOpenModal(false)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="#7A869A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke="#7A869A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
        <div className="row card-body pb-0">
        <div className="terms-auth pl-4">
          <div>
            <span>In accordance with </span> 
            <a 
              href='https://developers.facebook.com/docs/whatsapp/business-management-api/authentication-templates/' 
              target='_blank'
              className='cl-red'> 
              Meta's policy 
            </a> 
             <span> for authentication template types, OCA is currently making adjustments related to the policy. For the time being, please submit a WA authentication template using the following format: </span>
          </div>
          <div className='d-flex align-items-center justify-content-center my-3'>
            <div className='w-35 me-4'>
              <h3 className='fsize-12 fweight-700 cl-black mb-2'>Bahasa Indonesia</h3>
              <img src={TermUseBahasa} className='me-0 w-100'></img>
            </div>
            <div className='w-35'>
              <h3 className='fsize-12 fweight-700 cl-black mb-2'>English</h3>
              <img src={TermUseEnglish} className='me-0 w-100'></img>
            </div>
          </div>
          <div className='d-flex align-items-start border-top'>
            <div className='bahas-indonesia border-end w-50 pt-3 me-3 pe-3'>
              <p>Example for template in  <strong>Bahasa Indonesia :</strong> </p>
              <p className='mb-1'>Body: </p>
              <p>123456 adalah kode verifikasi Anda. Demi keamanan, jangan bagikan kode ini.</p>
              <p>apabila terdapat waktu kadaluarsa, silahkan input pada bagian footer dengan format:</p>
              <p className='mb-1'>Footer: </p>
              <p>Kode ini kadaluarsa dalam xx menit.</p>
              <p>xx = durasi menit dapat diganti sesuai dengan waktu kadaluarsa kode autentikasi.</p>
              <p className='mb-1'>Button:</p>
              <p>Salin kode</p>
            </div>
            <div className='bahas-english pt-3 w-50'>
              <p>Example for template in <strong>English :</strong> </p>
              <p className='mb-1'>Body: </p>
              <p>123456 is your verification code. For your security, do not share this code.</p>
              <p>If there is an expiration time, please input it in the footer section with the following format:</p>
              <p className='mb-1'>Footer: </p>
              <p>This code expired in xx minutes.</p>
              <p>xx = The minute duration can be changed according to the expiration time of the authentication code.</p>
              <p className='mb-1'>Button: </p>
              <p className='mb-0'>Copy code</p>
            </div>
          </div>
          </div>
        </div>
    </div>
    </Modal>
      <div className='oca-badge-info mb-0 mt-3'>
        <div className='d-flex align-items-center badge-terms'>
            <img src={AlertBlue} className='me-2'></img>
            <p className='mb-0'>Please read term of use for <strong>Authentication</strong>  template</p>
        </div>
        <button onClick={()=>setOpenModal(true)} className="btn cl-blue-primary">
            Read
        </button>
      </div>
    </div>
  )
}

export default TermUseAuth